import { render, staticRenderFns } from "./CallOrderManagement.vue?vue&type=template&id=eb927b94&scoped=true"
import script from "./CallOrderManagement.vue?vue&type=script&lang=js"
export * from "./CallOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./CallOrderManagement.vue?vue&type=style&index=0&id=eb927b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb927b94",
  null
  
)

export default component.exports